import React, { Fragment } from 'react';
import '../../key.css'
import CardActivate from '../card/CardActivate'

const MainKey = () => {
    return(
        <Fragment>
            <div className="key-holder">
                <CardActivate></CardActivate>
            </div>
        </Fragment>
    )
};

export default MainKey;
